import React, { useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faExchangeAlt, faPiggyBank } from '@fortawesome/free-solid-svg-icons';
import './FeatureCards.css';

interface FeatureCardsProps {
  showLightning?: boolean;
}

const FeatureCards: React.FC<FeatureCardsProps> = ({ showLightning = false }) => {
  const [rotatingIcons, setRotatingIcons] = useState<{[key: string]: boolean}>({
    time: false,
    exchange: false,
    money: false
  });

  const handleCardClick = (iconKey: string) => {
    // Set the clicked icon to rotate
    setRotatingIcons(prev => ({...prev, [iconKey]: true}));
    
    // Add console log for debugging
    console.log(`Icon ${iconKey} clicked, rotating:`, {[iconKey]: true});
    
    // Reset the animation after it completes
    setTimeout(() => {
      setRotatingIcons(prev => ({...prev, [iconKey]: false}));
    }, 600); // Match the animation duration
  };

  return (
    <div className="feature-cards-section">
      <Container fluid>
        <h2 className="text-center mb-5">Trusted Since 2023</h2>
        <Row>
          <Col md={4} className="mb-4">
            <Card className="feature-card" onClick={() => handleCardClick('time')}>
              <Card.Body>
                <div className={`feature-icon ${rotatingIcons.time ? 'rotate-icon' : ''}`}>
                  <FontAwesomeIcon icon={faBolt} />
                </div>
                <Card.Title>Save Time</Card.Title>
                <Card.Text>
                  Maximum exchange speed thanks to complete automation
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="feature-card" onClick={() => handleCardClick('exchange')}>
              <Card.Body>
                <div className={`feature-icon ${rotatingIcons.exchange ? 'rotate-icon' : ''}`}>
                  <FontAwesomeIcon icon={faExchangeAlt} />
                </div>
                <Card.Title>Make an Exchange</Card.Title>
                <Card.Text>
                  Choose the right strategy and make favorable operations
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="feature-card" onClick={() => handleCardClick('money')}>
              <Card.Body>
                <div className={`feature-icon ${rotatingIcons.money ? 'rotate-icon' : ''}`}>
                  <FontAwesomeIcon icon={faPiggyBank} />
                </div>
                <Card.Title>Save Money</Card.Title>
                <Card.Text>
                  Best exchange rates and minimal commissions
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FeatureCards;